import { render, staticRenderFns } from "./ReminderDialog3.vue?vue&type=template&id=1991c0c3&scoped=true"
import script from "./ReminderDialog3.vue?vue&type=script&lang=js"
export * from "./ReminderDialog3.vue?vue&type=script&lang=js"
import style0 from "./ReminderDialog3.vue?vue&type=style&index=0&id=1991c0c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1991c0c3",
  null
  
)

export default component.exports